import React, { useEffect, useRef } from 'react';

import { ArrowLeft } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import { IconText } from '@travel/ui';
import LoadingCircle from '@travel/ui/components/FlatButton/loadingCircle';
import useInfiniteScroll from '@travel/ui/components/ListWrapper/useInfiniteScroll';
import cx from '@travel/ui/utils/classnames';

import MediaList from 'components/MediaList';

import styles from './mediaGallery.module.scss';

import type { Review } from 'store/apiTypes';
import { useAppSelector } from 'store/hooks';
import { selectMediaConfig } from 'store/media/selector';
type Props = {
  mediaReviews: Review[];
  hasMore?: boolean;
  onClickMedia?: () => void;
  onClose?: () => void;
  isAppendFetching?: boolean;
  onScrollToBottom?: () => void;
};

const MediaGallery = (props: Props) => {
  const { mediaReviews, hasMore, onClickMedia, onClose, isAppendFetching, onScrollToBottom } =
    props;
  const scrollEl = useRef<HTMLDivElement | null>(null);

  useEffect(() => scrollEl.current?.scrollIntoView({ behavior: 'instant' }), []);
  useInfiniteScroll(scrollEl, undefined, !isAppendFetching, hasMore, onScrollToBottom, false, 100);
  const isEnableVideoUpload = useAppSelector(selectMediaConfig);

  return (
    <div
      className={cx(styles.mediaGalleryContainer, !hasMore && styles.fullMediaGalleryContainer)}
      ref={scrollEl}
    >
      <button
        onClick={onClose}
        className={styles.returnButton}
        data-testid="mediaGallery-returnToProviderReviewPage-button"
      >
        <IconText
          icon={<ArrowLeft size={20} />}
          text={
            <Translate
              id={isEnableVideoUpload ? 'Review.ReviewMedia' : 'Review.ReviewMediaNoVideo'}
              className={styles.returnButtonText}
            />
          }
          spaceBetween={8}
          className={styles.returnButtonIconText}
        />
      </button>
      <MediaList
        reviewMedia={mediaReviews}
        layout={'gallery'}
        mediaCardClassName={styles.clickable}
        onClickMedia={onClickMedia}
        shouldShowLikeCountOverlay
      />
      {hasMore && (
        <div className={styles.loadingSpinner} data-testid="mediaGallery-loadingSpinner-container">
          <LoadingCircle isLoading={true} classType="primary" />
        </div>
      )}
    </div>
  );
};

export default MediaGallery;
